<script>
export default {
  name: 'fab',
  props: {
    tag: {
      type: String,
      default: 'button'
    }
  },
  render (createElement) {
    return createElement(
      this.tag,
      {
        class: this.$style.button
      },
      this.$slots.default // array of children
    )
  }
}
</script>

<style module lang="scss">
.button {
  font-size: 16px;
  color: #fff;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 100%;
  background-color: $main-bg-darkest;
  cursor: pointer;
  box-shadow: 0 2px 3px 1px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
